import React from 'react';
import '../styles/BasementAnalysis.css';
import { Image } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';

function BasementAnalysis(props) {
    const { basementAnalysis, darkMode = false } = props;

    // Early return if no basement analysis data
    if (!basementAnalysis || basementAnalysis.subjectBasement === null || basementAnalysis.subjectBasement === undefined) {
        return null;
    }

    const textColorClass = darkMode ? 'colour-white' : 'colour-primary';
    const containerClass = darkMode ? 'bg-colour-dark-mode' : 'bg-colour-white';

    // Extract subject basement status and street view image
    const subjectBasement = basementAnalysis.subjectBasement;
    const subjectStreetView = basementAnalysis.subjectStreetView || null;

    // Determine text based on subject basement status
    const subheadingText = subjectBasement === true 
        ? "Subject has a basement" 
        : "Subject has no basement";
    
    const ruleText = subjectBasement === true
        ? "Prefer comps with basements"
        : "Prefer comps without basements";

    return (
        <div className={`basement-analysis-container ${containerClass}`}>
            {/* Section 1: Header */}
            <div className="basement-analysis-header">
                <h3 className={`heading-small-bold ${textColorClass}`}>
                    Basement analysis
                </h3>
                <p className={`body-regular ${textColorClass}`}>
                    {subheadingText}
                </p>
            </div>

            {/* Section 2: Street View Image */}
            {subjectStreetView ? (
                <div className="basement-analysis-image-section">
                    <img
                        src={subjectStreetView}
                        alt="Subject property street view"
                        className="basement-analysis-street-view-image"
                    />
                </div>
            ) : (
                <div className="basement-analysis-image-section basement-analysis-no-image">
                    <Image
                        className="basement-analysis-no-image-icon"
                        fill={colour.gray05}
                    />
                    <span className={`body-regular ${textColorClass}`}>
                        No street view image available
                    </span>
                </div>
            )}

            {/* Section 3: Rule */}
            <div className="basement-analysis-rule-section">
                <p className={`body-regular ${textColorClass}`}>
                    {ruleText}
                </p>
            </div>
        </div>
    );
}

export default BasementAnalysis;

